(function() {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Scroll Reveal (fade-in) --- */
  function initScrollReveal() {
    const elements = document.querySelectorAll('.pixkom-fade-in');
    if (!elements.length) return;

    if (prefersReducedMotion) {
      elements.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function(el) { observer.observe(el); });
  }

  /* --- Header Compact + Announcement Bar --- */
  function initHeaderCompact() {
    var header = document.querySelector('sticky-header');
    var announcement = document.querySelector('.pk-marquee-band');
    if (!header) return;

    var threshold = announcement ? announcement.offsetHeight : 50;
    var isCompact = false;

    function onScroll() {
      var shouldCompact = window.scrollY > threshold;
      if (shouldCompact === isCompact) return;
      isCompact = shouldCompact;

      if (isCompact) {
        header.classList.add('header-compact');
        document.body.classList.add('scrolled-past-announcement');
      } else {
        header.classList.remove('header-compact');
        document.body.classList.remove('scrolled-past-announcement');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Parallax Glow Orbs --- */
  function initParallaxGlow() {
    if (prefersReducedMotion) return;

    var glows = document.querySelectorAll('.pixkom-parallax-glow');
    if (!glows.length) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var offset = window.scrollY;
          glows.forEach(function(el) {
            el.style.transform = 'translateY(' + (offset * -0.1) + 'px)';
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Init all on DOM ready --- */
  document.addEventListener('DOMContentLoaded', function() {
    initScrollReveal();
    initHeaderCompact();
    initParallaxGlow();
  });
})();
